// extracted by mini-css-extract-plugin
module.exports = {"label":"VerticalDivider-module__label--1Nuiw","divider":"VerticalDivider-module__divider--1Xl79","container":"VerticalDivider-module__container--3K5fp"};